import React from 'react';

const FeaturedBooks = () => {
    const books = [
        {
            title: "Mi primer cuaderno de emociones",
            description: "Un viaje emocionante para crecer por dentro.",
            imageUrl: "/img/book.2.back.jpg",
            link: "https://www.amazon.es/Mi-primer-cuaderno-emociones-actividades/dp/B0D9LMVSKD"
        },
        {
            title: "Safari Coloring",
            description: "Colors of Africa: A Relaxing Journey Through the Savanna with 50 coloring pages for adults and teens.",
            imageUrl: "/img/book.2.front.jpg",
            link: "https://www.amazon.es/SAFARI-COLORING-BOOK-Relaxing-coloring/dp/B0D19FL17P"
        },
        {
            title: "My first workbook of emotions.",
            description: "Un misterio que cambiará la vida de sus protagonistas.",
            imageUrl: "/img/book.3.front.jpg",
            link: "https://www.amazon.es/My-first-workbook-emotions-activity/dp/B0D9LM6LNZ"
        },
        {
            title: "Mi Primera Comunion",
            description: "Libro de firmas y recuerdos: Versión extendida a todo color, con espacio para dedicatorias, álbum de fotos de comunión y árbol de ... únicos para niñas | Recuerdo inolvidable.",
            imageUrl: "/img/book.4.front.jpg",
            link: "https://www.amazon.es/dp/B0F88D5PH8"
        }
    ];

    return (
        <section className="bg-light py-5">
            <div className="container">
                <h2 className="text-center mb-4">Libros Destacados</h2>
                <div className="row">
                    {books.map((book, index) => (
                        <div className="col-md-3" key={index}>
                            <div className="card">
                                <a href={book.link}>
                                    <img src={book.imageUrl} className="card-img-top" alt={book.title} />
                                </a>
                                <div className="card-body">
                                    <h5 className="card-title">{book.title}</h5>
                                    <p className="card-text">{book.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturedBooks;